import { render } from "./ReviewRemarksDialog.vue?vue&type=template&id=5a25c6dc"
import script from "./ReviewRemarksDialog.vue?vue&type=script&lang=js"
export * from "./ReviewRemarksDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__